import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { InputComponent } from '../input/input.component';
import { InputPhoneComponent } from '../input-phone/input-phone.component';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-complete-profile',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, InputComponent, InputPhoneComponent, ButtonComponent, TranslateModule],
  templateUrl: './complete-profile.component.html',
})
export class CompleteProfileComponent implements OnInit {
  profileForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(2)]),
    phone: new FormControl(null, [Validators.required]),
  });

  isLoading = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const suggestedName = this.route.snapshot.queryParamMap.get('suggested_name');
    if (suggestedName) {
      this.profileForm.patchValue({ name: suggestedName });
    }
  }

  onSubmit(): void {
    this.profileForm.markAllAsTouched();
    if (this.profileForm.invalid) return;

    this.isLoading = true;
    this.errorMessage = '';

    const { name } = this.profileForm.value;
    const phoneObject = this.profileForm.get('phone')?.value as any;
    const phone = phoneObject?.e164Number ?? '';

    this.authService.completeProfile(name!, phone).subscribe({
      next: (response) => {
        this.authService.setToken(response.token);
        this.isLoading = false;
        this.router.navigate(['/']);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = err?.error?.message ?? 'Error al completar el perfil. Intentá de nuevo.';
      }
    });
  }
}
